import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import Autocomplete from 'react-google-autocomplete';
import config from 'client/shared/config';
import Field from './field';




class AutocompleteField extends Field {
    constructor(props) {
        super(props);
    }

	renderInput () {
		return (
			<div>
				<Autocomplete
                    apiKey={config.gapiKey}
					onPlaceSelected={this.onPlaceSelected}
					defaultValue={this.props.defaultValue}
                />
			</div>
		);
	}

	@autobind
	onChange (value) {
		console.log('[onChange - value]', value);
		// Make the arg look like an event object with a target
		this.handleChange({
			target: { value: value }
		});
    }
    
    @autobind
    onPlaceSelected (place) {
        console.log(place);
        this.onChange(place.formatted_address);
    }
    
}

export default AutocompleteField;
